import angular from 'angular';

/**
 * Collects the card number and PIN for a PHYSICAL gift card being activated from Order Details
 * (DEV-13089). Staff have to key them in because neither is readable anywhere in the app: they
 * are printed on the card itself and acme-core never persists them (the order payload carries
 * `lastFour` alone), it only relays them to the provider and discards them. The card number is
 * required; whether the PIN is gets decided downstream - see done().
 *
 * DIGITAL cards never reach this modal - the provider mints their number and PIN, so
 * OrdersDetailController posts for them directly.
 */
GiftCardActivateModalController.$inject = ['$scope', '$uibModalInstance'];

export function GiftCardActivateModalController($scope, $uibModalInstance) {
  const ctrl = {
    model: {
      cardNumber: '',
      pin: '',
    },

    errors: [] as { message: string }[],

    hasErrors: function () {
      return ctrl.errors.length > 0;
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    /**
     * Only the card number is checked here, because it's the only one acme-core itself requires:
     * its blank-card-number path claims the row and marks it ERRORED_ACTIVATION before
     * rejecting, so an empty submit would burn an activation_attempt against acme-relay's cap
     * for nothing.
     *
     * Whether a PIN is needed is the provider's call, not ours - it answers PIN_REQUIRED ("PIN
     * is required for this sale channel"), so the requirement varies by channel and this modal
     * has no way to know. Blocking on it here would lock staff out of activating a card on a
     * channel that doesn't use one. A blank PIN is omitted from the payload rather than sent as
     * an empty string, so the provider sees it as absent.
     */
    done: function () {
      ctrl.errors = [];

      if (!ctrl.model.cardNumber.trim()) {
        ctrl.errors.push({ message: 'Please enter the card number printed on the gift card.' });
        return;
      }

      const pin = ctrl.model.pin.trim();

      $uibModalInstance.close({
        cardNumber: ctrl.model.cardNumber.trim(),
        pin: pin || undefined,
      });
    },
  };

  $scope.giftCardActivateModal = ctrl;
}

export const GiftCardActivateModalControllerModule = angular
  .module('acme.view.application.orders.detail.controllers.gift-card-activate-modal', [])
  .controller('GiftCardActivateModalController', GiftCardActivateModalController).name;
